var r, a;
function c() {
  return a || (a = 1, r = function(e, _) {
    for (var o in e)
      _(e[o], o);
  }), r;
}
export {
  c as __require
};
